/** @format */
import * as Application from "expo-application";

/////////// Application Constants ///////////////////
export const VERSION = Application.nativeApplicationVersion || "1.0.0";

////////// API End Points /////////////////////
export const API_URL = "https://vault-api.umo.services/details/update";
export const DELETE_API_URL =
	"https://vault-api.umo.services/details/delete";
//export const RASA_HOST = "http://35.179.104.5"; // https://chat.umo.services";
export const RASA_HOST = "https://chat.umo.services";
export const PASSPORT_FILE_API_URL =
	"https://vault-api.umo.services/file/create-desc";
export const ORGANIZATION_ACCESS_URL =
	"https://vault-api.umo.services/access/verif";
export const PASSPORT_FILE_DELETE =
	"https://vault-api.umo.services/details/delete";

export const ONETOONE_HOST = "wss://vault-api.umo.services/chat";
//export const ONETOONE_HOST = "ws://localhost:9001/chat";


export const ENVIRONMENT = "prod"

export const WEB_MAXWIDTH = 700